import { useEffect, useRef, useState } from "react";

// TODO: withWindowCommunication, WindowCommunication context

interface IState {
  current: string;
}

const supportBroadcastAPI = typeof window !== "undefined" && "BroadcastChannel" in window;

const initialState = {
  current: ""
};

export function useWindowCommunication(name: string): [IState, (msg: string) => void] {
  const [state, setState] = useState<IState>(initialState);
  const broadCastChannel = useRef<BroadcastChannel | null>();

  if (supportBroadcastAPI) {
    broadCastChannel.current = new BroadcastChannel(name);
  }

  function updateStateMsg(msg: string): void {
    setState({ current: msg });
  }

  function sendMessage(msg: string): void {
    if (supportBroadcastAPI && broadCastChannel?.current) {
      broadCastChannel.current.postMessage(msg);
      return;
    }

    window.localStorage.setItem(name, msg);
  }

  function updateFromBroadcast(e: MessageEvent): void {
    updateStateMsg(e.data);
  }

  function updateFromLocalStorage(e: StorageEvent): void {
    if (e.newValue) {
      updateStateMsg(e.newValue);
    }
  }

  function onDestroy(): void {
    if (broadCastChannel?.current) {
      broadCastChannel.current.close();
      broadCastChannel.current = null;
      return;
    }

    window.localStorage.removeItem(name);
    window.removeEventListener("storage", updateFromLocalStorage);
  }

  useEffect(() => {
    if (supportBroadcastAPI && broadCastChannel?.current) {
      broadCastChannel.current.onmessage = updateFromBroadcast;
    } else {
      window.addEventListener("storage", updateFromLocalStorage);
    }

    return onDestroy;
  }, [name]);

  return [state, sendMessage];
}